<script>
  import { onMount, createEventDispatcher, onDestroy } from 'svelte';

  import BenableLogo from '@components/BenableLogo.svelte';
  import CurrentUser from '@components/CurrentUser.svelte';
  import Avatar from '@components/Avatar.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import ComponentEvents from '@utils/component-events';

  import AddButton from '../../profile/components/AddButton.svelte';
  import ProfileCollectionBar from './ProfileCollectionBar.svelte';

  const dispatch = createEventDispatcher();
  import jQuery from 'jquery';

  export let user;
  export let tablet = false;

  let currentUser = getCurrentUserStore('default');
  let showStickyNav = false;

  let setupStickyNav = () => {
    const element_position = jQuery('.profile-sections-heading').offset().top;
    const navBarHeight = 129;

    let previousScrollPosition;
    let scrollDirection;

    jQuery(window).on('scroll', function () {
      let top = jQuery(window).scrollTop();
      const y_scroll_pos = window.pageYOffset;
      const scroll_pos_test = element_position - navBarHeight;

      scrollDirection = previousScrollPosition < top ? 'down' : 'up';

      if (y_scroll_pos > scroll_pos_test && scrollDirection === 'up') {
        showStickyNav = true;
        jQuery('.profile-nav-bar').css('display', 'block');
      } else {
        showStickyNav = false;
      }

      previousScrollPosition = top;
    });
  };

  let unsubShowSticky = ComponentEvents.on('profile-sticky-nav-show-sticky', async (data) => {
    showStickyNav = data.showStickyNav;
  });

  onMount(() => {
    setupStickyNav();
  });

  onDestroy(() => {
    unsubShowSticky();
  });
</script>

<style style="text/scss" lang="scss">
  .profile-nav-bar {
    background: white;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 25;
    border-bottom: 1px solid #f0f0f0;
    display: none;

    .profile-nav-bar-grid {
      display: grid;
      grid-template-columns: 1fr minmax(auto, 1000px) 1fr;
      grid-gap: 1rem;
      align-items: flex-start;
      padding: 40px 90px;
      margin: 0 auto;
      max-width: 1660px;

      .profile-nav-bar-logo {
        margin-top: 10px;
      }
      .profile-nav-bar-content-container {
        display: flex;
        flex-direction: column;
        .profile-nav-bar-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
        }
      }
      .profile-nav-bar-action {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;

        .profile-actions-invite-button {
          margin-right: 12px;
        }
      }
    }

    .profile-collections-container {
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media only screen and (max-width: 1170px) {
    .profile-nav-bar {
      .profile-collections-container {
        max-width: 660px;
      }
    }
  }

  @media only screen and (max-width: 1378px) {
    .profile-nav-bar {
      .profile-nav-bar-grid {
        padding: 40px 60px;
      }
    }
  }

  @media only screen and (max-width: 1443px) {
    .profile-nav-bar {
      .profile-nav-bar-grid {
        .profile-nav-bar-logo {
          margin-left: -20px;
        }
      }
    }
  }

  @media only screen and (max-width: 1280px) {
    .profile-nav-bar {
      .profile-nav-bar-grid {
        .profile-nav-bar-logo {
          margin-left: -40px;
          margin-right: 10px;
        }
      }
    }
  }

  * :global(.group-collections-toggle) {
    height: 0px !important;
    top: 30px !important;
    display: block !important;
  }
</style>

{#if showStickyNav}
  <div class="profile-nav-bar">
    <div class="profile-nav-bar-grid">
      <div class="profile-nav-bar-logo">
        <BenableLogo />
      </div>
      <div class="profile-nav-bar-content-container">
        <div class="profile-nav-bar-content">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <div style="margin-right: 16px;">
              <Avatar src={user.avatar_url} width={48} user={user} />
            </div>
            <div style="font-size: 20px; font-weight: 700;">
              {user.name}
            </div>
          </div>
          <div>
            {#if user.id === currentUser.id}
              <AddButton
                user={user}
                on:added-group={(e) => {
                  dispatch('added-group', e.detail);
                }}
                on:added-collection={(e) => {
                  dispatch('added-collection', e.detail);
                }} />
            {/if}
          </div>
        </div>
      </div>
      <div class="profile-nav-bar-action">
        <CurrentUser currentPage="profile" />
      </div>
    </div>
    <div class="profile-collections-container">
      <ProfileCollectionBar tablet={tablet} user={user} />
    </div>
  </div>
{/if}
